import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import { Trans } from "react-i18next";
import { RTF } from "../elements/RTF";
import { SimpleLink } from "../elements/SimpleLink";

export const SlidePageLink: React.FC<{
  id: string;
  image?: IGatsbyImageData | null;
  alt?: string | null;
  heading?: string | null;
  title?: string | null;
  message?: IRichTextInformation | null;
  link?: string | null;
  linkTitle?: string | null;
}> = ({ alt, image, heading, title, message, link, linkTitle }) => {
  return (
    <section
      className="relative bg-cotton py-48px lg:py-150px"
      data-component="Slide Page Link"
    >
      <div className="page-grid max-width relative">
        {image && (
          <div
            className={classNames(
              "w-full",
              "col-span-6",
              "lg:col-start-8",
              "lg:col-span-8",
              "lg:order-2",
              "aspect-h-3",
              "aspect-w-5",
              "relative",
              "mb-48px",
              "lg:mb-0",
            )}
          >
            <div
              className={classNames(
                "absolute",
                "top-0",
                "left-0",
                "w-full",
                "h-full",
              )}
            >
              <GatsbyImage
                className={classNames("h-full", "w-full")}
                imgStyle={{
                  objectFit: "cover",
                  objectPosition: "contain",
                }}
                image={image}
                alt={alt ?? title ?? "Image"}
                loading="lazy"
              />
            </div>
          </div>
        )}
        <div
          className={classNames(
            "col-start-2",
            "col-span-3",
            "lg:col-start-2",
            "lg:col-span-5",
          )}
        >
          {heading && (
            <span
              className={classNames("block", "h5", "text-hyacinth", "mb-20px")}
            >
              {heading}
            </span>
          )}
          {title && <h2 className={classNames("h3", "mb-60px")}>{title}</h2>}
          {message && (
            <RTF
              className="text-right-margin mb-60px lg:mb-40px"
              content={message}
              fixedParagraphClassName="p4"
            />
          )}
          {link && (
            <SimpleLink className="" to={link}>
              {linkTitle ?? <Trans>Learn more</Trans>}
            </SimpleLink>
          )}
        </div>
      </div>{" "}
    </section>
  );
};
